import axios from "axios";
import { createActionErrorCapture, errorEnvelope } from '../../../utils/sentryUtils';
import { getToken, getTokenHeader } from "../../Common/Token";
import { getDashboardConfigUrl, getHomepageDataUrl } from "../Api";


const captureActionError = createActionErrorCapture('home');
export const getHomepageData = async (manufacturer_id = null) => {
  return new Promise(async (next) => {
    try {
      const token = await getToken();
      const params = manufacturer_id ? { manufacturer_id } : {};
      const { data } = await axios.get(getHomepageDataUrl(), {
        ...getTokenHeader(token),
        params,
      });
      return next(data);
    } catch (err) {
      captureActionError(err, 'getHomepageData', { manufacturer_id });
      return next(errorEnvelope(err, 'Something went wrong. Please try again.'));
    }
  });
};

export const getDashboardConfigData = async ({
  manufacturer_id,
}) => {
  return new Promise(async (next) => {
    try {
      const token = await getToken();
      const params = { manufacturer_id };
      const { data } = await axios.get(getDashboardConfigUrl(), {
        ...getTokenHeader(token),
        params,
      });
      return next(data);
    } catch (err) {
      captureActionError(err, 'getDashboardConfigData', { manufacturer_id });
      return next(errorEnvelope(err, 'Something went wrong'));
    }
  });
};
